import React from 'react';
import { NewsletterSignup } from './NewsletterSignup';

const LinktreePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-sage-50 to-white py-12 px-6 text-center font-sans">
      <div className="max-w-xl mx-auto space-y-8">
        {/* Header */}
        <div className="space-y-4">
          <div className="w-24 h-24 mx-auto rounded-full bg-gradient-to-br from-sage-400 to-lavender-400 flex items-center justify-center shadow-lg">
            <span className="text-3xl">🌿</span>
          </div>
          <h1 className="text-4xl font-serif text-sage-800 mb-2">Connect With Kirby</h1>
          <p className="text-sage-600 text-lg">All the ways to find, follow, and book with me in one place.</p>
        </div>
        {/* Highlight of the Month */}
        <div className="bg-gradient-to-r from-amber-50 to-orange-50 border-l-4 border-amber-400 p-6 shadow-lg rounded-xl">
          <h2 className="text-xl font-semibold text-sage-800 mb-2 flex items-center justify-center gap-2">
            <span>📌</span> Highlight of the Month
          </h2>
          <p className="text-sage-700 mb-4">Don't miss the <strong>early bird discount</strong> now live for Whale Retreat!</p>
          <a 
            href="https://whaleretreat.com.au" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block bg-gradient-to-r from-sage-500 to-sage-600 text-white px-8 py-3 rounded-lg hover:from-sage-600 hover:to-sage-700 transition-all duration-300 shadow-md hover:shadow-lg font-semibold"
          >
            View Retreat Details
          </a>
        </div>
        {/* Booking Links */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-sage-800 flex items-center justify-center gap-2">
            <span>📍</span> Find Me and Book a Session
          </h2>

          <a 
            href="https://book.nookal.com/bookings/book/EDb8e4e9-EcEB-465D-d079-32Dba6D5634d/practitioner" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="block bg-white shadow-lg rounded-xl py-4 px-6 text-sage-700 hover:bg-sage-50 hover:shadow-xl transition-all duration-300 border border-sage-100"
          >
            <div className="font-semibold">Women and the Way (Currimundi)</div>
            <div className="text-sm text-sage-500">Tues, Thurs, Sun</div>
          </a>
          <a 
            href="https://bloomchinesemedicine-au.janeapp.com/?hl=en-AU&gei=XLNSaLSkCbWm2roPh9jk4QE#/staff_member/18" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="block bg-white shadow-lg rounded-xl py-4 px-6 text-sage-700 hover:bg-sage-50 hover:shadow-xl transition-all duration-300 border border-sage-100"
          >
            <div className="font-semibold">Bloom Chinese Medicine (Maroochydore)</div>
            <div className="text-sm text-sage-500">Wed & Fri</div>
          </a>
        </div>


        {/* Instagram Accounts */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-sage-800 flex items-center justify-center gap-2">
            <span>📸</span> Follow on Instagram
          </h2>
          <a 
            href="https://www.instagram.com/dq_chinese_medicine" 
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-white rounded-xl py-3 px-6 shadow-lg hover:bg-sage-50 hover:shadow-xl transition-all duration-300 text-sage-700 border border-sage-100"
          >
            @dq_chinese_medicine
          </a>
          <a 
            href="https://www.instagram.com/women_and_the_way" 
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-white rounded-xl py-3 px-6 shadow-lg hover:bg-sage-50 hover:shadow-xl transition-all duration-300 text-sage-700 border border-sage-100"
          >
            @women_and_the_way
          </a>
          <a 
            href="https://www.instagram.com/the_way_wellness_hub/" 
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-white rounded-xl py-3 px-6 shadow-lg hover:bg-sage-50 hover:shadow-xl transition-all duration-300 text-sage-700 border border-sage-100"
          >
            @the_way_wellness_hub
          </a>
        </div>


        {/* Websites & Emails */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-sage-800 flex items-center justify-center gap-2">
            <span>🌐</span> Websites & Contact
          </h2>
          <div className="bg-white rounded-xl p-5 shadow-lg text-left border border-sage-100">
            <a 
              href="https://womenandtheway.com.au" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="font-semibold text-sage-800 hover:text-sage-600 transition-colors block"
            >
              womenandtheway.com.au
            </a>
            <a href="mailto:womenandtheway@gmail.com" className="text-sage-600 hover:text-sage-800 transition-colors block">womenandtheway@gmail.com</a>
          </div>
          <div className="bg-white rounded-xl p-5 shadow-lg text-left border border-sage-100">
            <a 
              href="https://thewaywellness.com.au" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="font-semibold text-sage-800 hover:text-sage-600 transition-colors block"
            >
              thewaywellness.com.au
            </a>
            <a href="mailto:hello@thewaywellness.com.au" className="text-sage-600 hover:text-sage-800 transition-colors block">hello@thewaywellness.com.au</a>
          </div>
          <div className="bg-white rounded-xl p-5 shadow-lg text-left border border-sage-100">
            <a 
              href="https://whaleretreat.com.au" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="font-semibold text-sage-800 hover:text-sage-600 transition-colors block"
            >
              whaleretreat.com.au
            </a>
            <a href="mailto:hello@whaleretreat.com.au" className="text-sage-600 hover:text-sage-800 transition-colors block">hello@whaleretreat.com.au</a>
          </div>
        </div>

              {/* Google Reviews */}
        {/* <div className="space-y-4">
          <h2 className="text-xl font-semibold text-sage-800 flex items-center justify-center gap-2">
            <span>⭐</span> Leave a Google Review
          </h2>
          <p className="text-sage-600">Your feedback supports our visibility and helps others find us.</p>
          <a 
            href="https://g.co/kgs/S8BqMWh" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block bg-white text-sage-700 px-8 py-3 rounded-lg shadow-lg hover:bg-sage-50 hover:shadow-xl transition-all duration-300 border border-sage-100 font-semibold"
          >
            Leave a Review
          </a>
        </div> */}

        {/* Newsletter CTA */}
        <div className="bg-gradient-to-r from-sage-500 to-sage-600 text-white p-8 rounded-xl shadow-lg">
          <h3 className="text-2xl font-serif mb-3">📝 Join the Newsletter</h3>
          <p className="text-sage-100 mb-6">Seasonal health tips, fertility wisdom & event invites delivered with love.</p>
          <div className="max-w-sm mx-auto">
            <NewsletterSignup 
              formType="newsletter"
              onSuccess={() => {
                // Optional: Add any success handling specific to linktree signup
              }}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="pt-8 border-t border-sage-200">
          <p className="text-sage-500 text-sm">Made with 💚 for your wellness journey</p>
        </div>
      </div>
    </div>
  );
};

export default LinktreePage; 